var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4433 41.7272C20.8903 34.6931 18.7284 21.0691 12.5176 16.5073C18.453 17.8375 20.5303 23.118 24.1551 23.0131C26.6986 22.9494 28.6392 19.759 29.6351 15.4297C29.2958 27.2155 23.5191 37.3965 15.4433 41.7272Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7524 20.5599C25.1934 20.5599 26.3593 19.2293 26.3593 17.6237C26.3593 15.9974 25.1934 14.6875 23.7524 14.6875C22.3316 14.6875 21.1445 15.9974 21.1445 17.6237C21.1445 19.2293 22.3316 20.5599 23.7524 20.5599Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7726 45.0293C11.7726 45.0293 21.6841 34.8007 15.1781 22.6918C12.5055 24.1451 16.2042 28.826 14.7027 30.114C7.3125 24.3928 13.9998 17.4886 10.2197 15.7109C8.2307 20.6573 7.73551 27.057 11.0629 32.2191C15.2614 38.7331 11.7726 45.0293 11.7726 45.0293Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8506 41.6451C16.8506 41.6451 25.2436 38.8783 29.11 25.9369C31.8886 26.5389 30.7405 30.5717 28.6266 33.0396C35.0875 31.8021 31.1199 20 34.7644 21.276C39.0924 41.2338 16.8506 41.6451 16.8506 41.6451Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4635 46.1838C5.11988 45.1268 2.64484 39.7948 2.43225 34.3326C2.37228 32.7815 2.40804 19.1094 2.40804 19.1094L0.0993719 21.1784C0.0993719 21.1784 -0.00463604 33.1563 0.000160975 36.982C0.198365 43.3886 4.97052 47.0494 9.55472 47.8357L10.4635 46.1838Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8656 21.1261L41.5526 19.0625C41.5526 19.0625 41.6193 32.7349 41.5621 34.2857C41.3476 40.1331 38.5431 45.8406 32.387 46.3186L22.02 46.4109C22.02 46.4109 17.7908 46.8063 11.6345 46.3414C11.5405 46.3342 11.4539 46.3151 11.3619 46.3053L9.83887 47.8766C10.4463 47.965 11.0501 48.0087 11.636 47.9952L32.389 47.9722C37.4816 48.0778 43.7882 44.3199 44.0003 36.9299C43.9964 33.1038 43.8656 21.1261 43.8656 21.1261Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9862 42.9084C7.89526 41.0883 6.75161 36.0526 6.74986 34.6534C6.74833 32.9974 6.61794 14.5781 6.61794 14.5781L4.30121 16.7832C4.30121 16.7832 4.28136 31.0161 4.28594 35.0967C4.22227 40.0658 8.0396 43.5647 11.3742 44.5027C11.5159 44.2111 11.7547 43.6643 11.9862 42.9084Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6547 16.7472L37.334 14.5469C37.334 14.5469 37.2435 32.9664 37.2453 34.6224C37.2475 36.276 35.6819 43.0288 29.5088 43.5385L14.5066 43.555C14.2528 43.5348 14.0184 43.4883 13.7798 43.4472C13.4009 43.9859 13.0642 44.4221 12.7969 44.7489C12.888 44.7533 12.9829 44.7663 13.0718 44.7663L30.9477 44.7463C34.509 44.7426 39.7984 40.9061 39.7109 35.0602C39.7059 30.9799 39.6547 16.7472 39.6547 16.7472Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6695 15.4916L9.90368 14.9091L10.4734 15.177C10.7549 15.3093 10.985 15.4661 11.181 15.6395C11.3901 15.7829 11.6753 15.9789 12.0139 16.2092C12.0894 16.0821 12.2084 15.9952 12.3427 15.9511C12.3737 12.1491 12.3992 9.21094 12.3992 9.21094L8.93643 12.1469C8.93643 12.1469 8.93512 14.4756 8.93359 17.6232C9.14226 16.9103 9.38495 16.1988 9.6695 15.4916Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2027 25.681C32.2206 25.4626 32.2384 25.2436 32.2546 25.0313C32.4109 23.0179 32.5341 21.4279 33.466 20.8228C33.8803 20.5534 34.384 20.5197 34.9616 20.7222L35.032 20.7468C35.0203 16.3179 35.0092 12.5268 35.0092 12.5268L31.54 9.30469C31.54 9.30469 31.6392 18.4381 31.7064 25.3101C31.8965 25.4498 32.0686 25.5784 32.2027 25.681Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9286 35.2992C30.3258 38.5746 26.5111 40.3041 23.25 41.2185L28.9502 41.212C31.5693 41.2094 35.0644 37.9013 35.0585 32.6788C35.0581 32.3137 35.0576 31.8972 35.0568 31.4453C34.5605 32.848 33.8534 34.1353 32.9286 35.2992Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4939 40.3121C12.6966 38.1291 12.3888 35.3694 10.5644 32.5401C9.87731 31.4731 9.33677 30.3111 8.93164 29.0859C8.93186 30.5173 8.93251 31.7749 8.9336 32.7065C8.93731 36.3058 10.6019 38.9911 12.4939 40.3121Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7933 20.0223C20.2608 20.4251 20.6988 20.7971 21.1253 21.128L21.124 19.6266C20.7651 19.057 20.5519 18.3678 20.5519 17.6232C20.5519 16.881 20.7627 16.1942 21.1195 15.6256L21.102 0L14.9102 6.6263L14.9213 16.6813C16.9559 17.5826 18.4937 18.9038 19.7933 20.0223Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.753 14.0986C25.5179 14.0986 26.9533 15.6804 26.9533 17.6254C26.9533 19.5704 25.5179 21.153 23.753 21.153C23.4332 21.153 23.1307 21.0854 22.8392 20.9885L22.8401 22.1709C23.2631 22.3371 23.6904 22.4351 24.1385 22.4216C26.1886 22.3708 28.0123 19.7468 29.0319 15.3983L29.0221 6.61283L22.8154 0L22.8313 14.2653C23.1251 14.1673 23.4305 14.0986 23.753 14.0986Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6d80d9533010d1da4b94f5df14c98d11.svg";
export { ForwardRef as ReactComponent };